import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    datapage: {
      Page: 'DeviceManagement',    //  Overview, DeviceManagement ,Report, Location, Map
      Level: 0
    },
    dataDashboard: {

    },
    UserToken: '',
  },
  mutations: {
    SET_DATAPAGE(state, payload) {
      state.datapage = payload;
    },
    SET_DATA_DASHBOARD(state, payload) {
      state.dataDashboard = payload;
    },
    SET_USER_TOKEN(state, payload) {
      state.UserToken = payload;
    },
  },
  actions: {},
  getters: {},
});
